/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router-dom';

import { baseUrlApp } from '@/routes';

import ModalParametresHubee from './ModalParametresHubee';

/**
 * Point de menu « Paramètres > HubEE » : ouvre la modal de paramétrage et
 * revient à l'accueil à sa fermeture.
 */
const ParametresHubee = () => {
  const history = useHistory();

  const handleClose = React.useCallback(() => {
    history.push(baseUrlApp);
  }, [history]);

  return <ModalParametresHubee onClose={handleClose} />;
};

export default ParametresHubee;
